import { useState } from 'react';

const FAQLuxury = () => {
    const faqs = [
        {
          question: "What makes a holiday truly 'luxurious'?",
          answer: "It's more than just fancy hotels and a hefty price tag! Luxury is about those unforgettable experiences, personalized service, and exquisite attention to detail. Think private villas with infinity pools overlooking breathtaking scenery, Michelin-starred dining experiences, personalized itineraries curated just for you, and seamless travel arrangements that take all the stress out of your getaway."
        },
        {
          question: "What are some of the most luxurious destinations in the world?",
          answer: "The world is your oyster! For island paradises, the Maldives, Bora Bora, and Seychelles offer unparalleled luxury with overwater bungalows, private beaches, and world-class spas. If you're seeking cultural immersion with a touch of opulence, consider destinations like Japan with its ryokans and exquisite cuisine, or India with its majestic palaces and vibrant traditions. And for European elegance, cities like Paris, Rome, and Switzerland offer a blend of history, culture, and high-end experiences."
        },
        {
          question: "What are some unique experiences I can have on a luxury holiday?",
          answer: "The possibilities are endless! Imagine a private helicopter tour over the Grand Canyon, a hot air balloon ride over the African savanna at sunrise, a personalized shopping experience with a stylist in Milan, or a private chef preparing a gourmet meal in your villa. Luxury travel is about creating those 'wow' moments that you'll cherish forever."
        },
        {
          question: "How can I make my luxury holiday more affordable?",
          answer: "While luxury travel often comes with a higher price tag, there are ways to make it more budget-friendly. Consider traveling during the shoulder seasons for lower rates, booking your flights and accommodations well in advance to secure the best deals, or opting for shorter stays. You can also look for luxury holiday packages that bundle your flights, accommodations, and activities, often offering significant savings."
        },
        {
          question: "What are some tips for planning the perfect luxury holiday?",
          answer: "Start by defining your vision of luxury. What experiences and amenities are most important to you? Then, research destinations and hotels that align with your preferences. Consider working with a travel specialist who can curate a personalized itinerary and handle all the details, ensuring a seamless and unforgettable experience. And don't forget to pack your sense of adventure and prepare to be pampered!"
        }
      ];
      

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQLuxury;
